import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', () => {

    const homePage = document.querySelector('.page-template-template-home')
    if (homePage !== null) {

        const heroThumbnailSlider = new Splide('.js-home-hero-slide-thumbnails', {
            arrows: false,
            pagination: false,
            isNavigation: true,
            drag: false,
        })

        const mainHeroSlide = new Splide('.js-home-hero-slide', {
            type: 'fade',
            arrows: false,
            pagination: false,
            drag: false,
        })

        mainHeroSlide.sync(heroThumbnailSlider)
        mainHeroSlide.mount()
        heroThumbnailSlider.mount()

    }
})
